/**
 * @fileoverview Month title and navigation controls for the home calendar.
 * @module components/HomeCalendar/CalendarHeader
 */

import { KeyboardArrowDown } from "@mui/icons-material";
import styles from "./HomeCalendar.module.css";

const EXPAND_ICON_TRANSITION = "transform 0.3s ease-in-out";
const EXPAND_ICON_OPEN = "rotate(180deg)";
const EXPAND_ICON_CLOSED = "rotate(0deg)";

/**
 * Month title and the controls that move within the allowed month range.
 * Previous is disabled on the current month. Next is disabled on the next month.
 * The arrow rotation reflects whether the grid is expanded.
 * @param {Object} props
 * @param {Object} props.state
 * @param {Object} props.actions
 */
const CalendarHeader = ({ state, actions }) => {
  const { t } = state;
  const previousClassName = state.isCurrentMonth ? styles.disabled : "";
  const nextClassName = state.isNextMonth ? styles.disabled : "";

  return (
    <div className={styles.header}>
      <div className={styles.titleSection}>
        <h2 className={styles.title}>
          {t("pages.events.header")} {state.monthName} {state.year}
        </h2>
        <div className={styles.controlsSection}>
          <button className={styles.todayButton} onClick={actions.goToToday}>
            {t("pages.viewAppointments.today")}
          </button>
          <button
            className={`${styles.navButton} ${previousClassName}`}
            onClick={actions.goToPreviousMonth}
            disabled={state.isCurrentMonth}
            aria-label={t("common.previous")}
          >
            ‹
          </button>
          <button
            className={`${styles.navButton} ${nextClassName}`}
            onClick={actions.goToNextMonth}
            disabled={state.isNextMonth}
            aria-label={t("common.next")}
          >
            ›
          </button>
        </div>
      </div>
      <button
        className={styles.expandButton}
        onClick={actions.toggleCalendarExpansion}
        aria-label={
          state.isExpanded
            ? t("common.collapseCalendar")
            : t("common.expandCalendar")
        }
      >
        <KeyboardArrowDown
          className={styles.expandIcon}
          sx={{
            transform: state.isExpanded ? EXPAND_ICON_OPEN : EXPAND_ICON_CLOSED,
            transition: EXPAND_ICON_TRANSITION,
          }}
        />
      </button>
    </div>
  );
};

export default CalendarHeader;
